import store from '@/store';
import router from '@/router';

/**
 * Añade una entrada al bloc de pruebas (desde vistas o consola: vm.$debugNote).
 */
export function pushDebugEntry(payload) {
  const route = payload.route !== undefined ? payload.route : routeSnapshot();
  store.commit('debugLog/push', { ...payload, route });
}

export function captureVistaContext(extra) {
  let user = '';
  try {
    user = store.getters['auth/user'] || '';
  } catch {
    user = '';
  }
  const lines = [
    `URL: ${typeof window !== 'undefined' ? window.location.href : ''}`,
    `Usuario (store): ${user || '(no disponible)'}`,
    `Viewport: ${typeof window !== 'undefined' ? `${window.innerWidth}x${window.innerHeight}` : ''}`,
    `UA: ${typeof navigator !== 'undefined' ? navigator.userAgent : ''}`,
  ];
  if (extra !== undefined && extra !== null && extra !== '') {
    lines.push('Extra:', typeof extra === 'string' ? extra : JSON.stringify(extra, null, 2));
  }
  pushDebugEntry({
    type: 'vista',
    title: 'Datos de vista',
    body: lines.join('\n'),
  });
}

export function routeSnapshot() {
  try {
    const r = router?.currentRoute?.value;
    if (!r) return null;
    return {
      name: r.name,
      path: r.path,
      fullPath: r.fullPath,
      params: { ...r.params },
      query: { ...r.query },
    };
  } catch {
    return null;
  }
}

export function formatEntriesForExport(entries) {
  const blocks = entries.map((e) => {
    const r = e.route ? `\nRuta: ${e.route.fullPath || e.route.path} (${e.route.name || ''})` : '';
    const stack = e.stack ? `\nStack:\n${e.stack}` : '';
    const vi = e.vueInfo ? `\nVue: ${e.vueInfo}` : '';
    return `--- [${e.type}] ${e.at} ---${r}\n${e.title}\n${e.body || '(sin detalle)'}${stack}${vi}`;
  });
  return blocks.join('\n\n');
}
